<template>
  <div class="month-nav" role="group" aria-label="Mes">
    <button type="button" aria-label="Mes anterior" @click="shift(-1)">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"/>
      </svg>
    </button>
    <span class="month-nav__label" aria-live="polite">{{ label }}</span>
    <button type="button" aria-label="Mes siguiente" @click="shift(1)">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { formatPeriod, shiftPeriod } from '@/utils/period'

// Selector de mes: ‹ Agosto 2026 ›. Lo usan Planilla, Impuestos y el detalle de
// propiedad — un componente, no una copia del markup en cada vista. Modela un
// período 'YYYY-MM' (ver utils/period). Queda pendiente de migrar el tablero de
// Recaudación (`collection/Dashboard.vue`), que todavía usa dos <select>.
//
// Una sola API: v-model. Quien tenga que reconsultar al cambiar de mes pone un
// watch sobre su propio período, no un segundo evento.
export default {
  name: 'MonthNav',
  props: {
    modelValue: { type: String, required: true }
  },
  emits: ['update:modelValue'],
  computed: {
    label () { return formatPeriod(this.modelValue) }
  },
  methods: {
    shift (delta) {
      this.$emit('update:modelValue', shiftPeriod(this.modelValue, delta))
    }
  }
}
</script>
